import { AppConfig } from '@/config';
import { useUserProfileStore } from './accounts/UserProfileStore';

const storeRegistry = new Map<Function, Store>();

export function useStore<T extends Store>(ctor: new () => T): T {
  if (!storeRegistry.has(ctor)) {
    storeRegistry.set(ctor, new ctor());
  }
  return storeRegistry.get(ctor) as T;
}

export abstract class Store {
  private readonly cacheMs: number;

  constructor(cacheMs: number) {
    this.cacheMs = cacheMs;
  }

  public get CacheMs(): number {
    return this.cacheMs;
  }

  protected get userStore() {
    return useUserProfileStore();
  }

  EnsureLoggedOn() {
    if (!this.userStore.hasSession) {
      throw new Error('User is not logged in');
    }
  }

  protected ResolveUrl(template: string): string {
    template = template.trim();

    if (template.includes('{{accountId}}') || template.includes('{{userId}}')) {
      this.EnsureLoggedOn();
    }
    const userKey = this.userStore.getCurrentUserKey();
    const resolved = template
      .replace('{{apiHost}}', AppConfig.apiHost || '{{apiHost}}')
      .replace('{{accountId}}', userKey!.accountId || '{{accountId}}')
      .replace('{{userId}}', userKey!.userId || '{{userId}}');

    if (resolved.includes('{{')) {
      throw new Error(`Unresolved template variables in: ${resolved}`);
    }
    return resolved;
  }
}
